import React from "react"
import ReactDOM from "react-dom"
// 放到苍穹页面直接使用
import ModelTest, {Mypostal} from "../src/componets/index/index"
import eventBus from "../src/util/eventBus"
import {createStore} from "redux"
import {modelTestReducer} from "../src/componets/reducer/reducer"
import {Provider} from "react-redux"
import {errorMessage, initData, modelTestInit, modelTestUpdate} from "../src/componets/action/action"
import {isProduction} from "../src/function/checkProduct"
;(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            this.passageway = new Date().getTime()
            this.store = createStore(modelTestReducer)
            this.store.dispatch(modelTestInit())
            isProduction ? console.log("-----init", this.model.style, props) : null
            KDApi.loadFile("./main.css", this.model, () => {
                ReactDOM.render(
                    <Provider store={this.store}>
                        <ModelTest passageway={this.passageway} model={this.model} />
                    </Provider>,
                    this.model.dom
                )
            })
        },
        update: function (props) {
            isProduction ? console.log("-----update", this.model, props) : null
            if (props.data !== undefined) {
                if ("modelTest" in props.data) {
                    this.store.dispatch(modelTestUpdate(props.data.modelTest))
                } else if ("errorMessage" in props.data) {
                    this.model.invoke("resultData", {
                        code: "0",
                        message: props.data.errorMessage,
                    })
                    this.store.dispatch(errorMessage(props.data.errorMessage))
                } else if ("initData" in props.data) {
                    this.store.dispatch(initData(props.data.initData))
                }
            }
        },
        destoryed: function () {
            eventBus.unsub(Mypostal)
            isProduction ? console.log("-----destoryed", this.model) : null
        },
    }

    // 注册自定义组件
    KDApi.register("ai-cvp-ocr-modelTest", MyComponent)
})(window.KDApi)

console.log("modeltest: <<<<<<<<<<<<<<<<<<<<<<<SS_TIME_STAMP>>>>>>>>>>>>>>>>>>>>>")
